export const VAULT_TAB = {
  FORMS: 'forms',
  DOCUMENTS: 'documents',
  MORTGAGE_TIMELINE: 'mortgage-timeline',
} as const;

export type VaultTab = (typeof VAULT_TAB)[keyof typeof VAULT_TAB];
